
import { defineComponent, PropType, ref, Ref } from "vue";
import { formatDateTime } from "../../mixins";
import { Notification } from "../../../../../domain/entities/notifications/notification";

const __default__ = defineComponent({
  name: "NotificationItem",
  props: {
    notification: {
      type: Object as PropType<Notification>,
      required: true
    }
  },
  methods: { formatDateTime },
  setup(props) {
    const image: Ref<string> = ref(`url(${props.notification.image})`);
    return { image };
  }
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "fe2c628e": (_ctx.image)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__